import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import content from './modules/content';
import video from './modules/video';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: false,
  },
  getters: {
    error: state => state.error,
  },
  mutations: {
    setError(state, error) {
      state.error = error;
    },
  },
  modules: {
    auth,
    content,
    video,
  },
});
